import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import Select from 'react-select';
import useDataBean from '../../../../../core/services/dataBean/useDataBean';
import { _ErrorDetails, _QualityErrorDetails, _QualityErrorTypes, _QualityMeasurementInspectionsItems, _SeverityLevels } from '../../../../../core/services/dataBean/EntityCatalog';
import usePaginator from '../../../../theme/Component/usePaginator';

interface Props {
    idSelector: number;
    idQualittyInspections: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
}

export const SelectQualityMeasurementInspectionsItems = ({ idSelector, onChange, label, returnType = "ID", idQualittyInspections }: Props) => {
    const { instance, bean, setBean, lista, setLista } = useDataBean(_QualityMeasurementInspectionsItems);
    const paginador = usePaginator();

    const [selectedOption, setSelectedOption] = useState<any>(null);

    useEffect(() => {
        if (idQualittyInspections) {
            getLista();
        }
    }, [idQualittyInspections]);

    useEffect(() => {
        if (idSelector && lista.length > 0) {
            const found = lista.find(item => item.DataBeanProperties.IDQualityMeasurementInspectionsItems === idSelector);
            if (found) {
                setSelectedOption({
                    value: found.DataBeanProperties.IDQualityMeasurementInspectionsItems,
                    label: `${found.DataBeanProperties.ConstantName} (${found.DataBeanProperties.DefaultValue} ${found.DataBeanProperties.TypeName} ${found.DataBeanProperties.Tolerance ?? ""})`,
                    item: found
                });
            }
        }
    }, [idSelector, lista]);

    const getLista = () => {
        const props = {
            State: 1,
            IDQualityMeasurementInspections: idQualittyInspections
        }
        instance.getQualityMeasurementInspectionsItemsRender(null, null, props).then((resp: any) => {
            setLista(resp.List);
            paginador.setPages(resp.NumberOfPages);
        }).catch(err => {
            toast.error("Error al cargar la lista de Tolerancias");
        });
    };

    const handleChange = (option: any) => {
        setSelectedOption(option);
        if (!option) {
            if (onChange)
                onChange(returnType === "Object" ? {} : null);
        } else {

            if (onChange) {
                onChange(returnType === "Object" ? option.item.DataBeanProperties : option.value);
            }
        }
    };

    const options = lista.map((item: any) => ({
        value: item.DataBeanProperties.IDQualityMeasurementInspectionsItems,
        label: `${item.DataBeanProperties.ConstantName} (${item.DataBeanProperties.DefaultValue} ${item.DataBeanProperties.TypeName} ${item.DataBeanProperties.Tolerance ?? ""})`,
        item: item
    }));

    return (
        <div>
            {label && label != " " &&
                < label > {label ?? "Medida de Cota"}</label>
            }
            <Select
                options={options}
                value={selectedOption}
                onChange={handleChange}
                isClearable
                placeholder="Selecciona una Medida de Cota..."
                noOptionsMessage={() => "Sin coincidencias"}
            />
        </div >
    );
};
